import {
	// 合作伙伴列表
	partnerPageApi,
	// 合作伙伴
	partnerDetailApi,
	// 服务费等级列表	
	rateLevelPageApi,
	// 删除服务费等级
	delRateLevelApi,
	// 创建服务费等级
	createLevelApi,
	// 更新服务费等级
	updateLevelApi,
	// 设置等级（含通过注册审核）
	setLevelApi,
	// 拒绝注册
	rejectRegisterApi,
	orderReportApi
} from '@/apis/admin.js'
export default {
	async partnerPage(context, params) {
		return partnerPageApi(params)
	},
	async partnerDetail(context, id) {
		return partnerDetailApi(id)
	},
	async rateLevelPage(context, params) {
		return rateLevelPageApi(params)
	},
	async delRateLevel(context, params) {
		return delRateLevelApi(params)
	},
	async createLevel(context, body) {
		return createLevelApi(body)
	},
	async updateLevel(context, body) {
		return updateLevelApi(body)
	},
	async setLevel(context, body) {
		return setLevelApi(body)
	},
	async rejectRegister(context, {id, body}) {
		return rejectRegisterApi(id, {...body, status: 1})
	},
	async orderReport(context, params) {
		return orderReportApi(params)
	}
}